import { useQuery } from "@tanstack/react-query";
import { adminService } from "@/services/adminService";

/**
 * Copilot usage and tool reliability for the admin dashboard.
 *
 * @param days - Window size in days (server clamps to 1–365).
 */
export const useCopilotAnalytics = (days = 30) => {
  return useQuery({
    queryKey: ["admin", "copilot-analytics", days],
    queryFn: () => adminService.getCopilotAnalytics(days),
    // Aggregates over a multi-day window; no need to refetch on every focus.
    staleTime: 5 * 60 * 1000,
  });
};
